import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { StockItemstransferEntity } from "./stock-transfer-items-entity";

@Entity('stock_transfer')
export class StocktransferEntity{
  
    @PrimaryGeneratedColumn("increment",{name:'id'})
id:number;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"item_type"
})
itemType:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"challan_type"
})
challanType:string;


@Column("varchar",{
    nullable: true,
    length:20,
    name:"challan_no"
})
challanNo:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"challan_date"
})
challandate:Date;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"po_no"
})
poNo:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"bill_from"
})
billFrom:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"purpose"
})
purpose:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"address_code"
})
addressCode:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"address_details"
})
addressDetails:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"receiprnt"
})
receipent:string;


@Column("int",{
    nullable: true,
    name:"employee"
})
employee:number;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"ref_order"
})
refOrder:string;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"value"
})
value:string;

@Column("varchar",{
    nullable: true,
    name:"lr"
})
lr:string;

@Column("varchar",{
    nullable: true,
    name:"weight"
})
weight:string;

@Column("varchar",{
    nullable: true,
    name:"rolls"
})  
rolls:string;

@Column("varchar",{
    nullable: true,
    name:"status"
})
status:string;

@Column("varchar",{
    nullable: true,
    name:"e_way_bill"
})
eWayBill:string;


@Column("int",{
    nullable: true,
    name:"from_loaction"
})
fromLocation:number;

@Column("int",{
    nullable: true,
    name:"from_rack"
})
fromRack:number;

@Column("int",{
    nullable: true,
    name:"to_location"
})
toLocation:number;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"remarks"
})
remarks:string;


@Column("int",{
    nullable: true,
    name:"ref_no"
})
refNo:number;

@Column("boolean",{
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
})
createdUser: string | null;

@UpdateDateColumn({
    name: "updated_at",
    type:'datetime'
})
updatedAt: Date;

@Column("varchar", {
    nullable: true,
    name: "updated_user"
})
updatedUser: string | null;

@VersionColumn({
    default:1,
    name: "version_flag"
})
versionFlag: number;

@OneToMany(type=>StockItemstransferEntity, item=>item.stockInfo,{cascade: true})
itemInfo:StockItemstransferEntity[];


}
